<div class="flex flex-col gap-1 font-archivo-regular">
  <label *ngIf="label" [for]="id" class="block text-gray-1200 lg:text-[1.125rem] md:text-[1.125rem] sm:text-[1.125rem] xs:text-[1.125rem] text-[1rem] font-normal font-archivo leading-[29px]">
    {{label}}
    <span *ngIf="required" class="text-danger-500"> * </span>
  </label>
  <div class="relative inline-block w-full" #datePickerContainer>
    <div class="relative">
      <!-- Loading Skeleton -->
      @if (isLoading) {
      <div @skeletonFadeIn class="absolute inset-0 flex items-center px-3 pointer-events-none z-20 bg-transparent rounded-lg border border-gray-600 shadow-sm lg:h-[3.625rem] md:h-[3.625rem] sm:h-[3.625rem] xs:h-[3.625rem] h-[3rem]"
        [ngClass]="{
          'outline outline-1 -outline-offset-1 outline-danger-500': hasError,
          'focus-within:outline focus-within:outline-1 focus-within:-outline-offset-1 focus-within:outline-gray-500': !hasError
        }">
        <div class="w-48 h-6 bg-gray-200 rounded skeleton-shimmer relative"></div>
      </div>
      }

      <div class="group flex justify-between lg:h-[3.625rem]  md:h-[3.625rem]   sm:h-[3.625rem]  xs:h-[3.625rem]  h-[3rem] items-center border border-gray-600 rounded-lg shadow-sm relative z-0"
        [style.opacity]="isLoading ? '0' : '1'"
        [style.transition]="'opacity 200ms ease-out'"
        [style.background-color]="isLoading ? 'transparent' : null"
        [ngClass]="[
      hasError ? 'outline outline-1 -outline-offset-1 outline-danger-500' : 'focus-within:outline focus-within:outline-1 focus-within:-outline-offset-1 focus-within:outline-gray-500',
      disabled ? 'bg-gray-200 pointer-events-none cursor-not-allowed' : ''
     ]">
        <input #inputElement type="text" [id]="id" [placeholder]="placeholder" [disabled]="disabled || isLoading"
          [readOnly]="!allowInput"
          [attr.inputmode]="allowInput && usesUsDateMask() ? 'numeric' : null"
          [attr.maxlength]="allowInput && usesUsDateMask() ? 10 : null"
          (mousedown)="onInputMouseDown($event)"
          (click)="onInputClick($event)"
          (pointerdown)="!isLoading && !allowInput && toggleCalendar()"
          (focus)="onInputFocus()"
          (keydown)="onInputKeyDown($event)"
          (input)="onInputChange($event)"
          (blur)="onInputBlur($event)"
          niTooltip [tooltip]="inputValue"
          autocomplete="new-password" [attr.data-form-type]="'other'"
          class="peer w-full pl-3 py-[9px] rounded-lg pointer-events-auto outline-none focus:ring-0 lg:text-[1.25rem] md:text-[1.25rem] sm:text-[1.25rem] xs:text-[1.25rem] text-[1rem] font-archivo placeholder:text-gray-500 placeholder:font-archivo placeholder:lg:text-[1.25rem] placeholder:md:text-[1.25rem] placeholder:xs:text-[1.25rem] placeholder:text-[1rem] bg-transparent"
          [ngClass]="{
            'cursor-pointer': !allowInput || disabled === false,
            'cursor-text': allowInput && !disabled,
            'bg-gray-200 border-none font-bold': disabled,
            '!bg-transparent border-gray-600 focus:border-gray-500 border-0': !disabled && theme === 'light',
            '!bg-transparent border-gray-600 bg-secondary-800 text-secondary-200 focus:border-gray-500': !disabled && theme === 'dark',
            'pr-8': clearable && hasClearableValue()
          }" />

        <!-- Clear button -->
        <button  type="button" tabindex="-1" *ngIf="!disabled && clearable && hasClearableValue() && !isLoading"
          class="flex items-center"
          [ngClass]="{ 'text-secondary-400': theme === 'light', 'text-secondary-500': theme === 'dark' }"
          class="pl-2 py-2 rounded-full transition-colors relative overflow-hidden"
          (click)="rangeMode ? clearRangeDate($event) : clearDate($event); startRipple($event, 'clear')">
          <svg  *ngIf="!disabled" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
          <span *ngIf="rippleState.show && rippleState.target === 'clear'"
            class="absolute inset-0 bg-secondary-400 rounded-full opacity-25" [@rippleAnimation]></span>
        </button>

        <!-- Calendar icon -->
        <div *ngIf="!disabled" class="p-2 cursor-pointer" (pointerdown)="$event.stopPropagation(); toggleCalendar()" niTooltip [tooltip]="inputValue">
          <NiFormIcon icon="DateRange" class="w-4 h-4" />
        </div>
      </div>
    </div>

    <div class="flex items-end justify-between min-h-[25px]">
      <span *ngIf="hasError" class="flex items-end justify-between text-danger-500 text-[14px]">{{errorMessage}}</span>
    </div>


    <!-- Calendar popup with custom shadow on all sides -->
    <div *ngIf="(isOpen || inline) && !disabled" [@calendarAnimation] [ngClass]="{
           'absolute z-[9999] transform transition-all duration-200 ease-in-out': !inline,
           'bg-white': theme === 'light',
           'bg-secondary-800 text-secondary-200': theme === 'dark',
           'rounded-lg border w-96': true
         }" [style.top]="calendarPosition === 'above' ? 'auto' : '75%'"
      [style.bottom]="calendarPosition === 'above' ? '100%' : 'auto'"
      [style.margin-top]="calendarPosition === 'below' ? '4px' : '0'"
      [style.margin-bottom]="calendarPosition === 'above' ? '4px' : '0'"
      [style.box-shadow]="'0 0 15px rgba(0, 0, 0, 0.2)'" class="overflow-hidden">
      <!-- Month navigation -->
      <div class="flex justify-between items-center p-3"
        [ngClass]="{'bg-white border-b border-secondary-200': theme === 'light', 'bg-secondary-800 border-b border-secondary-700': theme === 'dark'}">
        <button type="button" [disabled]="isDisabledNavigationButton('prev')"
          class="p-2 rounded-full transition-colors relative overflow-hidden cursor-pointer" [ngClass]="{
            'text-secondary-700 hover:bg-secondary-100 disabled:text-secondary-300 disabled:cursor-not-allowed': theme === 'light',
            'text-secondary-300 hover:bg-secondary-700 disabled:text-secondary-600 disabled:cursor-not-allowed': theme === 'dark'
          }" (click)="prevMonth(); startRipple($event, 'prevMonth')">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
          <span *ngIf="rippleState.show && rippleState.target === 'prevMonth'"
            class="absolute inset-0 bg-secondary-400 rounded-full opacity-25" [@rippleAnimation]></span>
        </button>
        <div class="flex items-center space-x-2">
          <!-- Custom month dropdown -->
          <div class="relative">
            <button type="button" [ngClass]="{
                'hover:bg-secondary-100 focus:bg-secondary-200': theme === 'light',
                'hover:bg-secondary-700 focus:bg-secondary-600': theme === 'dark'
              }"
              class="px-2.5 py-1.5 text-base bg-transparent rounded-md flex items-center transition-colors font-medium"
              (click)="toggleMonthDropdown($event); startRipple($event, 'monthDropdown')">
              {{ months[currentMonth] }}
              <svg xmlns="http://www.w3.org/2000/svg"
                [ngClass]="{'text-secondary-500': theme === 'light', 'text-secondary-400': theme === 'dark'}"
                class="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
              <span *ngIf="rippleState.show && rippleState.target === 'monthDropdown'"
                class="absolute inset-0 bg-secondary-400 rounded-md opacity-25" [@rippleAnimation]></span>
            </button>
            <div *ngIf="monthDropdownOpen" [@dropdownAnimation]
              [ngClass]="{'bg-white shadow-md': theme === 'light', 'bg-secondary-800 shadow-lg': theme === 'dark'}"
              class="absolute z-10 mt-1 left-0 rounded-md max-h-48 overflow-y-auto w-36">
              <div class="grid grid-cols-1 p-1">
                <button *ngFor="let month of months; let i = index" type="button" [ngClass]="{
                    'bg-primary-50 text-primary-600 font-medium': i === currentMonth && theme === 'light',
                    'bg-primary-900 text-primary-200 font-medium': i === currentMonth && theme === 'dark',
                    'hover:bg-secondary-100': theme === 'light',
                    'hover:bg-secondary-700': theme === 'dark'
                  }" class="px-3 py-1.5 text-left text-sm rounded-md transition-colors relative overflow-hidden"
                  (click)="selectMonth(i, $event); startRipple($event, 'month-'+i)">
                  {{ month }}
                  <span *ngIf="rippleState.show && rippleState.target === 'month-'+i"
                    class="absolute inset-0 bg-primary-400 rounded-md opacity-25" [@rippleAnimation]></span>
                </button>
              </div>
            </div>
          </div>

          <!-- Custom year dropdown -->
          <div class="relative">
            <button type="button" [ngClass]="{
                'hover:bg-secondary-100 focus:bg-secondary-200': theme === 'light',
                'hover:bg-secondary-700 focus:bg-secondary-600': theme === 'dark'
              }"
              class="px-2.5 py-1.5 text-base bg-transparent rounded-md flex items-center transition-colors font-medium"
              (click)="toggleYearDropdown($event); startRipple($event, 'yearDropdown')">
              {{ currentYear }}
              <svg xmlns="http://www.w3.org/2000/svg"
                [ngClass]="{'text-secondary-500': theme === 'light', 'text-secondary-400': theme === 'dark'}"
                class="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
              <span *ngIf="rippleState.show && rippleState.target === 'yearDropdown'"
                class="absolute inset-0 bg-secondary-400 rounded-md opacity-25" [@rippleAnimation]></span>
            </button>
            <div *ngIf="yearDropdownOpen" [@dropdownAnimation] #yearDropdownRef
              [ngClass]="{'bg-white shadow-md': theme === 'light', 'bg-secondary-800 shadow-lg': theme === 'dark'}"
              class="absolute z-10 mt-1 left-0 rounded-md max-h-48 overflow-y-auto w-28">
              <div class="grid grid-cols-1 p-1">
                <button *ngFor="let year of yearOptions" type="button" [ngClass]="{
                    'bg-primary-50 text-primary-600 font-medium': year === currentYear && theme === 'light',
                    'bg-primary-900 text-primary-200 font-medium': year === currentYear && theme === 'dark',
                    'hover:bg-secondary-100': theme === 'light',
                    'hover:bg-secondary-700': theme === 'dark'
                  }" class="px-3 py-1.5 text-left text-sm rounded-md transition-colors relative overflow-hidden"
                  (click)="selectYear(year, $event); startRipple($event, 'year-'+year)">
                  {{ year }}
                  <span *ngIf="rippleState.show && rippleState.target === 'year-'+year"
                    class="absolute inset-0 bg-primary-400 rounded-md opacity-25" [@rippleAnimation]></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <button type="button" [ngClass]="{
                 'text-secondary-600 hover:bg-secondary-100 focus:bg-secondary-200': theme === 'light',
                 'text-secondary-300 hover:bg-secondary-700 focus:bg-secondary-600': theme === 'dark'
               }" class="p-1.5 rounded-full transition-colors relative overflow-hidden"
          (click)="nextMonth(); startRipple($event, 'nextMonth')">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
          </svg>
          <span *ngIf="rippleState.show && rippleState.target === 'nextMonth'"
            class="absolute inset-0 bg-secondary-400 rounded-full opacity-25" [@rippleAnimation]></span>
        </button>
      </div>

      <!-- Weekdays header -->
      <div class="grid grid-cols-7 gap-0 text-center text-base py-2 px-2"
        [ngClass]="{'border-b border-secondary-200': theme === 'light', 'border-b border-secondary-700': theme === 'dark'}">
        <div *ngIf="showWeekNumbers"
          [ngClass]="{'text-secondary-500': theme === 'light', 'text-secondary-400': theme === 'dark'}"
          class="font-medium py-1">
          #
        </div>
        <div *ngFor="let day of weekdayLabels"
          [ngClass]="{'text-secondary-500': theme === 'light', 'text-secondary-400': theme === 'dark'}"
          class="font-medium py-1">
          {{ day }}
        </div>
      </div>

      <!-- Calendar days -->
      <div class="p-2" [@monthAnimation]="currentMonthViewState">
        <div *ngFor="let week of calendarDays" class="grid grid-cols-7 gap-1 mb-1">
          <div *ngIf="showWeekNumbers"
            [ngClass]="{'text-secondary-500': theme === 'light', 'text-secondary-400': theme === 'dark'}"
            class="flex items-center justify-center h-8 text-xs">
            {{ getWeekNumber(week[0]) }}
          </div>
          <button *ngFor="let day of week; let dayIndex = index" type="button"
            [disabled]="!isInCurrentMonth(day) || isDisabled(day)"
            class="flex items-center justify-center h-10 w-10 text-base rounded-full transition-all duration-150 relative overflow-hidden focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-primary-500"
            [ngClass]="{
                 'bg-primary-500 text-white': isStartDate(day) || isEndDate(day) || isSelected(day),
                 'hover:bg-primary-600 shadow-sm': isStartDate(day) || isEndDate(day) || isSelected(day),
                 'bg-primary-100': isInRange(day) && !isStartDate(day) && !isEndDate(day) && theme === 'light',
                 'bg-primary-900 bg-opacity-25': isInRange(day) && !isStartDate(day) && !isEndDate(day) && theme === 'dark',
                 'cursor-not-allowed opacity-60': isDisabled(day),
                 'text-secondary-400': !isInCurrentMonth(day) && theme === 'light',
                 'text-secondary-600': !isInCurrentMonth(day) && theme === 'dark',
                 'hover:bg-secondary-100': !isSelected(day) && !isDisabled(day) && !isInRange(day) && isInCurrentMonth(day) && theme === 'light',
                 'hover:bg-secondary-700': !isSelected(day) && !isDisabled(day) && !isInRange(day) && isInCurrentMonth(day) && theme === 'dark',
                 'text-primary-600 font-semibold ring-1 ring-primary-100': isToday(day) && !isSelected(day) && !isStartDate(day) && !isEndDate(day) && theme === 'light',
                 'text-primary-400 font-semibold ring-1 ring-primary-900': isToday(day) && !isSelected(day) && !isStartDate(day) && !isEndDate(day) && theme === 'dark',
                 'text-secondary-800': isInCurrentMonth(day) && !isToday(day) && !isSelected(day) && !isDisabled(day) && !isInRange(day) && theme === 'light',
                 'text-secondary-200': isInCurrentMonth(day) && !isToday(day) && !isSelected(day) && !isDisabled(day) && !isInRange(day) && theme === 'dark',
                 'rounded-l-full': isStartDate(day) || (isInRange(day) && dayIndex === 0), 
                 'rounded-r-full': isEndDate(day) || (isInRange(day) && dayIndex === 6)
               }"
            (click)="rangeMode ? handleRangeSelection(day) : selectDate(day); startRipple($event, 'day-'+day.getTime())">
            {{ day.getDate() }}
            <span *ngIf="rippleState.show && rippleState.target === 'day-'+day.getTime()"
              class="absolute inset-0 bg-secondary-400 rounded-full opacity-25" [@rippleAnimation]></span>
          </button>
        </div>
      </div>

      <!-- Update the regular time picker to hide when in range mode -->
      <div *ngIf="enableTime && !rangeMode" class="p-3 border-t flex justify-center items-center space-x-2" [ngClass]="{
             'bg-secondary-50 border-secondary-200': theme === 'light',
             'bg-secondary-850 border-secondary-700': theme === 'dark'
           }">
        <div class="relative">
          <input type="number" [id]="hoursInputId" [attr.min]="use24Hour ? 0 : 1" [attr.max]="use24Hour ? 23 : 12"
            [value]="getDisplayHours()" (input)="onTimeInputChange($event, 'hour')"
            (blur)="validateTimeInput($event, 'hour')" (keydown)="preventInvalidTimeChars($event)" [ngClass]="{
              'border-secondary-300 focus:border-primary-500 cursor-text': theme === 'light',
              'border-secondary-600 bg-secondary-700 text-secondary-200 focus:border-primary-400 cursor-text': theme === 'dark'
            }" class="w-14 py-1.5 px-2 border rounded text-center focus:outline-none transition-colors text-sm" />
          <label [for]="hoursInputId" class="absolute -top-2 left-2 text-xs px-1" [ngClass]="{
                  'text-secondary-500 bg-secondary-50': theme === 'light',
                  'text-secondary-400 bg-secondary-850': theme === 'dark'
                }">
            Hours
          </label>
        </div>
        <span [ngClass]="{'text-secondary-700': theme === 'light', 'text-secondary-300': theme === 'dark'}">:</span>
        <div class="relative">
          <input type="number" [id]="minutesInputId" [attr.min]="0" [attr.max]="59"
            [value]="selectedDate ? padZero(selectedDate.getMinutes()) : '00'"
            (input)="onTimeInputChange($event, 'minute')" (blur)="validateTimeInput($event, 'minute')"
            (keydown)="preventInvalidTimeChars($event)" [ngClass]="{
              'border-secondary-300 focus:border-primary-500': theme === 'light',
              'border-secondary-600 bg-secondary-700 text-secondary-200 focus:border-primary-400': theme === 'dark'
            }" class="w-14 py-1.5 px-2 border rounded text-center focus:outline-none transition-colors text-sm" />
          <label [for]="minutesInputId" class="absolute -top-2 left-2 text-xs px-1" [ngClass]="{
                  'text-secondary-500 bg-secondary-50': theme === 'light',
                  'text-secondary-400 bg-secondary-850': theme === 'dark'
                }">
            Minutes
          </label>
        </div>

        <!-- Custom AM/PM selector -->
        <div *ngIf="!use24Hour" class="relative">
          <div class="flex border rounded overflow-hidden" [ngClass]="{
                 'border-secondary-300': theme === 'light',
                 'border-secondary-600': theme === 'dark'
               }">
            <button type="button" class="py-1.5 px-2 text-sm transition-colors relative overflow-hidden" [ngClass]="{
                'bg-primary-500 text-white': selectedDate && selectedDate.getHours() < 12,
                'bg-secondary-100 text-secondary-700 hover:bg-secondary-200': !(selectedDate && selectedDate.getHours() < 12) && theme === 'light',
                'bg-secondary-700 text-secondary-300 hover:bg-secondary-600': !(selectedDate && selectedDate.getHours() < 12) && theme === 'dark'
              }" (click)="setAmPm('AM'); startRipple($event, 'am-btn')">
              AM
              <span *ngIf="rippleState.show && rippleState.target === 'am-btn'"
                class="absolute inset-0 bg-secondary-400 rounded-none opacity-25" [@rippleAnimation]></span>
            </button>
            <button type="button" class="py-1.5 px-2 text-sm transition-colors relative overflow-hidden" [ngClass]="{
                'bg-primary-500 text-white': selectedDate && selectedDate.getHours() >= 12,
                'bg-secondary-100 text-secondary-700 hover:bg-secondary-200': !(selectedDate && selectedDate.getHours() >= 12) && theme === 'light',
                'bg-secondary-700 text-secondary-300 hover:bg-secondary-600': !(selectedDate && selectedDate.getHours() >= 12) && theme === 'dark'
              }" (click)="setAmPm('PM'); startRipple($event, 'pm-btn')">
              PM
              <span *ngIf="rippleState.show && rippleState.target === 'pm-btn'"
                class="absolute inset-0 bg-secondary-400 rounded-none opacity-25" [@rippleAnimation]></span>
            </button>
          </div>
        </div>
      </div>

      <!-- Range time picker remains as is -->
      <div *ngIf="enableTime && rangeMode" class="p-3 border-t flex flex-col space-y-2" [ngClass]="{
             'bg-secondary-50 border-secondary-200': theme === 'light',
             'bg-secondary-850 border-secondary-700': theme === 'dark'
           }">
        <!-- Start Date Time -->
        <div class="flex items-center">
          <span class="text-xs font-medium mr-2 min-w-16" [ngClass]="{
                  'text-secondary-600': theme === 'light',
                  'text-secondary-400': theme === 'dark'
                }">
            Start:
          </span>
          <div class="flex items-center space-x-2">
            <div class="relative">
              <input type="number" [attr.min]="use24Hour ? 0 : 1" [attr.max]="use24Hour ? 23 : 12"
                [value]="getStartHours()" (input)="onRangeTimeInputChange($event, 'hour', 'start')"
                (blur)="validateRangeTimeInput($event, 'hour', 'start')" (keydown)="preventInvalidTimeChars($event)"
                [ngClass]="{
                  'border-secondary-300 focus:border-primary-500': theme === 'light',
                  'border-secondary-600 bg-secondary-700 text-secondary-200 focus:border-primary-400': theme === 'dark'
                }" class="w-12 py-1 px-2 border rounded text-center focus:outline-none transition-colors text-xs" />
            </div>
            <span [ngClass]="{'text-secondary-700': theme === 'light', 'text-secondary-300': theme === 'dark'}">:</span>
            <div class="relative">
              <input type="number" [attr.min]="0" [attr.max]="59"
                [value]="startDate ? padZero(startDate.getMinutes()) : '00'"
                (input)="onRangeTimeInputChange($event, 'minute', 'start')"
                (blur)="validateRangeTimeInput($event, 'minute', 'start')" (keydown)="preventInvalidTimeChars($event)"
                [ngClass]="{
                  'border-secondary-300 focus:border-primary-500': theme === 'light',
                  'border-secondary-600 bg-secondary-700 text-secondary-200 focus:border-primary-400': theme === 'dark'
                }" class="w-12 py-1 px-2 border rounded text-center focus:outline-none transition-colors text-xs" />
            </div>
            <div *ngIf="!use24Hour" class="relative">
              <div class="flex border rounded overflow-hidden h-6" [ngClass]="{
                     'border-secondary-300': theme === 'light',
                     'border-secondary-600': theme === 'dark'
                   }">
                <button type="button" class="px-1.5 text-xs transition-colors relative overflow-hidden" [ngClass]="{
                    'bg-primary-500 text-white': startDate && startDate.getHours() < 12,
                    'bg-secondary-100 text-secondary-700 hover:bg-secondary-200': !(startDate && startDate.getHours() < 12) && theme === 'light',
                    'bg-secondary-700 text-secondary-300 hover:bg-secondary-600': !(startDate && startDate.getHours() < 12) && theme === 'dark'
                  }" (click)="setRangeAmPm('AM', 'start')">
                  AM
                </button>
                <button type="button" class="px-1.5 text-xs transition-colors relative overflow-hidden" [ngClass]="{
                    'bg-primary-500 text-white': startDate && startDate.getHours() >= 12,
                    'bg-secondary-100 text-secondary-700 hover:bg-secondary-200': !(startDate && startDate.getHours() >= 12) && theme === 'light',
                    'bg-secondary-700 text-secondary-300 hover:bg-secondary-600': !(startDate && startDate.getHours() >= 12) && theme === 'dark'
                  }" (click)="setRangeAmPm('PM', 'start')">
                  PM
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- End Date Time -->
        <div class="flex items-center">
          <span class="text-xs font-medium mr-2 min-w-16" [ngClass]="{
                  'text-secondary-600': theme === 'light',
                  'text-secondary-400': theme === 'dark'
                }">
            End:
          </span>
          <div class="flex items-center space-x-2">
            <div class="relative">
              <input type="number" [attr.min]="use24Hour ? 0 : 1" [attr.max]="use24Hour ? 23 : 12"
                [value]="getEndHours()" (input)="onRangeTimeInputChange($event, 'hour', 'end')"
                (blur)="validateRangeTimeInput($event, 'hour', 'end')" (keydown)="preventInvalidTimeChars($event)"
                [ngClass]="{
                  'border-secondary-300 focus:border-primary-500': theme === 'light',
                  'border-secondary-600 bg-secondary-700 text-secondary-200 focus:border-primary-400': theme === 'dark'
                }" class="w-12 py-1 px-2 border rounded text-center focus:outline-none transition-colors text-xs" />
            </div>
            <span [ngClass]="{'text-secondary-700': theme === 'light', 'text-secondary-300': theme === 'dark'}">:</span>
            <div class="relative">
              <input type="number" [attr.min]="0" [attr.max]="59"
                [value]="endDate ? padZero(endDate.getMinutes()) : '00'"
                (input)="onRangeTimeInputChange($event, 'minute', 'end')"
                (blur)="validateRangeTimeInput($event, 'minute', 'end')" (keydown)="preventInvalidTimeChars($event)"
                [ngClass]="{
                  'border-secondary-300 focus:border-primary-500': theme === 'light',
                  'border-secondary-600 bg-secondary-700 text-secondary-200 focus:border-primary-400': theme === 'dark'
                }" class="w-12 py-1 px-2 border rounded text-center focus:outline-none transition-colors text-xs" />
            </div>
            <div *ngIf="!use24Hour" class="relative">
              <div class="flex border rounded overflow-hidden h-6" [ngClass]="{
                     'border-secondary-300': theme === 'light',
                     'border-secondary-600': theme === 'dark'
                   }">
                <button type="button" class="px-1.5 text-xs transition-colors relative overflow-hidden" [ngClass]="{
                    'bg-primary-500 text-white': endDate && endDate.getHours() < 12,
                    'bg-secondary-100 text-secondary-700 hover:bg-secondary-200': !(endDate && endDate.getHours() < 12) && theme === 'light',
                    'bg-secondary-700 text-secondary-300 hover:bg-secondary-600': !(endDate && endDate.getHours() < 12) && theme === 'dark'
                  }" (click)="setRangeAmPm('AM', 'end')">
                  AM
                </button>
                <button type="button" class="px-1.5 text-xs transition-colors relative overflow-hidden" [ngClass]="{
                    'bg-primary-500 text-white': endDate && endDate.getHours() >= 12,
                    'bg-secondary-100 text-secondary-700 hover:bg-secondary-200': !(endDate && endDate.getHours() >= 12) && theme === 'light',
                    'bg-secondary-700 text-secondary-300 hover:bg-secondary-600': !(endDate && endDate.getHours() >= 12) && theme === 'dark'
                  }" (click)="setRangeAmPm('PM', 'end')">
                  PM
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>